import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  id,
  delay = 0
}) => {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={`py-20 md:py-32 px-6 md:px-12 max-w-6xl mx-auto ${className}`} data-id="element-220">
      {children}
    </motion.section>;
};